import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  createPKS,
  deletePKS,
  getPKS,
  getPKSById,
  updatePKS,
  verifyPKSByHead,
  bulkCreatePKS,
} from "libs/api/pks";

// PKS Thunk
export const getPKSThunk = createAsyncThunk(
  "pks/get",
  async ({
    cbPending,
    cbFulfilled,
    cbRejected,
    cbFinally,
    pathname,
    queryParams,
    headers,
  }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await getPKS(pathname, queryParams, headers);
      typeof cbFulfilled === "function" && cbFulfilled(response);

      return response?.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  },
);

// ==============================|| GET PKS BY ID THUNK ||============================== //
export const getPKSByIdThunk = createAsyncThunk(
  "pks/getById",
  async ({
    cbPending,
    cbFulfilled,
    cbRejected,
    cbFinally,
    pathname, // pathname ini akan berisi URL spesifik, misal: '/pks/12345'
  }) => {
    try {
      typeof cbPending === "function" && cbPending();

      // Memanggil fungsi API getPKSById
      const response = await getPKSById(pathname);

      typeof cbFulfilled === "function" && cbFulfilled(response);

      return response?.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  },
);

// Create PKS Thunk
export const createPKSThunk = createAsyncThunk(
  "pks/create",
  async ({
    cbPending,
    cbFulfilled,
    cbRejected,
    cbFinally,
    pathname,
    accessToken,
    body,
  }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await createPKS(pathname, body, accessToken);
      typeof cbFulfilled === "function" && cbFulfilled(response);
      return response;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  },
);

// Update PKS Thunk
export const updatePKSThunk = createAsyncThunk(
  "pks/update",
  async ({
    cbPending,
    cbFulfilled,
    cbRejected,
    cbFinally,
    pathname,
    body,
    accessToken,
  }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await updatePKS(pathname, body, accessToken);
      typeof cbFulfilled === "function" && cbFulfilled(response);
      return response;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  },
);

// Delete Role Thunk
export const deletePKSThunk = createAsyncThunk(
  "pks/delete",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, pathname, body }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await deletePKS(pathname, body);
      typeof cbFulfilled === "function" && cbFulfilled(response);
      return response;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  },
);

// Verify PKS Thunk
export const verifyPKSByHeadThunk = createAsyncThunk(
  "pks/verify",
  async ({
    cbPending,
    cbFulfilled,
    cbRejected,
    cbFinally,
    pathname,
    accessToken,
    body,
  }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await verifyPKSByHead(pathname, body, accessToken);
      typeof cbFulfilled === "function" && cbFulfilled(response);
      return response;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  },
);

// Create PKS Thunk
export const submitPKSThunk = createAsyncThunk(
  "pks/submit",
  async ({
    cbPending,
    cbFulfilled,
    cbRejected,
    cbFinally,
    pathname,
    accessToken,
    body,
  }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await createPKS(pathname, body, accessToken);
      typeof cbFulfilled === "function" && cbFulfilled(response);
      return response;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  },
);

// Bulk Create PKS Thunk
export const bulkCreatePKSThunk = createAsyncThunk(
  "pks/bulkCreate",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, pks }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await bulkCreatePKS(pks);
      typeof cbFulfilled === "function" && cbFulfilled(response?.data);
      return response?.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  },
);
